var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.0001L11.2045 3.04557C11.6438 2.60623 12.3562 2.60623 12.7955 3.04557L21.75 12.0001M4.5 9.75007V19.8751C4.5 20.4964 5.00368 21.0001 5.625 21.0001H9.75V16.1251C9.75 15.5038 10.2537 15.0001 10.875 15.0001H13.125C13.7463 15.0001 14.25 15.5038 14.25 16.1251V21.0001H18.375C18.9963 21.0001 19.5 20.4964 19.5 19.8751V9.75007M8.25 21.0001H16.5",
    stroke: "#46494B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c5a01402e5bc46b3b59b098655c78541.svg";
export { ForwardRef as ReactComponent };